import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './socialetiquette.json';

const Socialetiquette = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Learn polite English for social situations, cultural norms, and modern manners. B2 level exercises including grammar, vocabulary, and discussion."
            level="B2"
            title="Social Etiquette"
            image="/Images/fashion.webp"
            seoTitle="Free English Lesson Plans: Social Etiquette"
            seoDescription="Learn polite English for social situations, cultural norms, and modern manners. B2 level exercises including grammar, vocabulary, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Socialetiquette;


